varying vec2 vUv;
uniform sampler2D dissolveTexture;
uniform float dissolveValue;
uniform lowp int lastEvent;
uniform float lastEventTime;
uniform float iGlobalTime;
